import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { PlatformFaqComponent } from './platform-faq.component';
import { AddFaqComponent } from './add-faq/add-faq.component';
import { EditFaqComponent } from './edit-faq/edit-faq.component';

@NgModule({
  declarations: [PlatformFaqComponent, AddFaqComponent, EditFaqComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [PlatformFaqComponent, AddFaqComponent, EditFaqComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlatformFaqModule {}
